[
  {
    "id": "warrior_cleave",
    "classId": "warrior",
    "name": "Heavy Strike",
    "unlockLevel": 1,
    "cooldownMs": 6000,
    "castMs": 0,
    "mpCost": 10,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 1.6
      }
    ]
  },
  {
    "id": "warrior_shield_bash",
    "classId": "warrior",
    "name": "Shield Bash",
    "unlockLevel": 5,
    "cooldownMs": 12000,
    "castMs": 0,
    "mpCost": 12,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.9
      },
      {
        "type": "status",
        "status": "stun",
        "durationMs": 1500
      },
      {
        "type": "status",
        "status": "slow",
        "pct": 40,
        "durationMs": 4000,
        "playersOnly": true
      }
    ]
  },
  {
    "id": "warrior_war_cry",
    "classId": "warrior",
    "name": "War Cry",
    "unlockLevel": 10,
    "cooldownMs": 30000,
    "castMs": 0,
    "mpCost": 15,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "taunt",
        "radius": 8
      },
      {
        "type": "buff",
        "scope": "party",
        "stat": "def",
        "pct": 10,
        "durationMs": 10000
      }
    ]
  },
  {
    "id": "warrior_charge",
    "classId": "warrior",
    "name": "Charge",
    "unlockLevel": 15,
    "cooldownMs": 15000,
    "castMs": 0,
    "mpCost": 10,
    "range": 12,
    "target": "enemy",
    "effects": [
      {
        "type": "dash"
      },
      {
        "type": "status",
        "status": "slow",
        "pct": 40,
        "durationMs": 3000
      }
    ]
  },
  {
    "id": "warrior_iron_skin",
    "classId": "warrior",
    "name": "Iron Skin",
    "unlockLevel": 20,
    "cooldownMs": 60000,
    "castMs": 0,
    "mpCost": 20,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "buff",
        "scope": "self",
        "stat": "damageTaken",
        "pct": -40,
        "durationMs": 6000
      }
    ]
  },
  {
    "id": "warrior_sprint",
    "classId": "warrior",
    "name": "Sprint",
    "unlockLevel": 1,
    "cooldownMs": 9000,
    "castMs": 0,
    "mpCost": 2,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "buff",
        "scope": "self",
        "stat": "moveSpeed",
        "pct": 55,
        "durationMs": 8000
      }
    ]
  },
  {
    "id": "rogue_twin_strike",
    "classId": "rogue",
    "name": "Twin Strike",
    "unlockLevel": 1,
    "cooldownMs": 2000,
    "castMs": 0,
    "mpCost": 5,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.44,
        "hits": 2
      }
    ]
  },
  {
    "id": "rogue_venom_blade",
    "classId": "rogue",
    "name": "Venom Blade",
    "unlockLevel": 5,
    "cooldownMs": 3000,
    "castMs": 0,
    "mpCost": 6,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.6
      },
      {
        "type": "dot",
        "mult": 0.3,
        "durationMs": 6000,
        "tickMs": 1000
      }
    ]
  },
  {
    "id": "rogue_shadow_step",
    "classId": "rogue",
    "name": "Shadow Step",
    "unlockLevel": 10,
    "cooldownMs": 18000,
    "castMs": 0,
    "mpCost": 12,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "stealth",
        "durationMs": 5000,
        "moveSpeedPct": 30
      }
    ]
  },
  {
    "id": "rogue_hamstring",
    "classId": "rogue",
    "name": "Hamstring",
    "unlockLevel": 15,
    "cooldownMs": 6000,
    "castMs": 0,
    "mpCost": 8,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.6
      },
      {
        "type": "status",
        "status": "root",
        "durationMs": 2000
      }
    ]
  },
  {
    "id": "rogue_ambush",
    "classId": "rogue",
    "name": "Ambush",
    "unlockLevel": 20,
    "cooldownMs": 8000,
    "castMs": 0,
    "mpCost": 12,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 1.2,
        "stealthMult": 2.5
      }
    ]
  },
  {
    "id": "rogue_swift",
    "classId": "rogue",
    "name": "Swift",
    "unlockLevel": 1,
    "cooldownMs": 9000,
    "castMs": 0,
    "mpCost": 2,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "buff",
        "scope": "self",
        "stat": "moveSpeed",
        "pct": 90,
        "durationMs": 8000
      }
    ]
  },
  {
    "id": "mage_firebolt",
    "classId": "mage",
    "name": "Firebolt",
    "unlockLevel": 1,
    "cooldownMs": 0,
    "castMs": 1000,
    "mpCost": 12,
    "range": 20,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 1.0
      }
    ]
  },
  {
    "id": "mage_frost_nova",
    "classId": "mage",
    "name": "Frostbite",
    "unlockLevel": 5,
    "cooldownMs": 14000,
    "castMs": 0,
    "mpCost": 20,
    "range": 20,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.9
      },
      {
        "type": "status",
        "status": "freeze",
        "durationMs": 1500
      }
    ]
  },
  {
    "id": "mage_blink",
    "classId": "mage",
    "name": "Blink",
    "unlockLevel": 10,
    "cooldownMs": 20000,
    "castMs": 0,
    "mpCost": 15,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "blink",
        "distance": 10
      }
    ]
  },
  {
    "id": "mage_meteor",
    "classId": "mage",
    "name": "Meteor",
    "unlockLevel": 20,
    "cooldownMs": 25000,
    "castMs": 1000,
    "mpCost": 30,
    "range": 16,
    "target": "point",
    "effects": [
      {
        "type": "damage",
        "mult": 3.0,
        "area": {
          "shape": "circle_point",
          "radius": 5
        }
      }
    ]
  },
  {
    "id": "mage_sprint",
    "classId": "mage",
    "name": "Sprint",
    "unlockLevel": 1,
    "cooldownMs": 9000,
    "castMs": 0,
    "mpCost": 2,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "buff",
        "scope": "self",
        "stat": "moveSpeed",
        "pct": 55,
        "durationMs": 8000
      }
    ]
  },
  {
    "id": "priest_smite",
    "classId": "priest",
    "name": "Smite",
    "unlockLevel": 1,
    "cooldownMs": 0,
    "castMs": 1000,
    "mpCost": 10,
    "range": 20,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.9
      }
    ]
  },
  {
    "id": "priest_mend",
    "classId": "priest",
    "name": "Mend",
    "unlockLevel": 5,
    "cooldownMs": 0,
    "castMs": 1000,
    "mpCost": 18,
    "range": 20,
    "target": "ally",
    "effects": [
      {
        "type": "heal",
        "mult": 1.8
      }
    ]
  },
  {
    "id": "priest_blessing",
    "classId": "priest",
    "name": "Blessing",
    "unlockLevel": 15,
    "cooldownMs": 120000,
    "castMs": 0,
    "mpCost": 25,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "buff",
        "scope": "party",
        "stat": "ap",
        "pct": 8,
        "durationMs": 600000
      },
      {
        "type": "buff",
        "scope": "party",
        "stat": "maxHp",
        "pct": 8,
        "durationMs": 600000
      }
    ]
  },
  {
    "id": "priest_sprint",
    "classId": "priest",
    "name": "Sprint",
    "unlockLevel": 1,
    "cooldownMs": 9000,
    "castMs": 0,
    "mpCost": 2,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "buff",
        "scope": "self",
        "stat": "moveSpeed",
        "pct": 55,
        "durationMs": 8000
      }
    ]
  },
  {
    "id": "warrior_sunder",
    "classId": "warrior",
    "name": "Sunder Armor",
    "unlockLevel": 30,
    "cooldownMs": 12000,
    "castMs": 0,
    "mpCost": 25,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 1.2
      },
      {
        "type": "debuff",
        "stat": "def",
        "pct": -25,
        "durationMs": 10000
      }
    ]
  },
  {
    "id": "warrior_execute",
    "classId": "warrior",
    "name": "Executioner's Blow",
    "unlockLevel": 45,
    "cooldownMs": 18000,
    "castMs": 0,
    "mpCost": 35,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 3.6
      }
    ]
  },
  {
    "id": "rogue_crippling_venom",
    "classId": "rogue",
    "name": "Crippling Venom",
    "unlockLevel": 30,
    "cooldownMs": 5000,
    "castMs": 0,
    "mpCost": 12,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.6
      },
      {
        "type": "dot",
        "mult": 1.2,
        "durationMs": 8000,
        "tickMs": 1000
      },
      {
        "type": "status",
        "status": "slow",
        "pct": 35,
        "durationMs": 6000
      }
    ]
  },
  {
    "id": "rogue_blade_flurry",
    "classId": "rogue",
    "name": "Blade Flurry",
    "unlockLevel": 40,
    "cooldownMs": 4000,
    "castMs": 0,
    "mpCost": 12,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.4,
        "hits": 4
      }
    ]
  },
  {
    "id": "mage_flame_wave",
    "classId": "mage",
    "name": "Flame Wave",
    "unlockLevel": 25,
    "cooldownMs": 10000,
    "castMs": 0,
    "mpCost": 30,
    "range": 8,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 1.6,
        "area": {
          "shape": "cone",
          "radius": 8,
          "angleDeg": 90,
          "maxTargets": 8
        }
      }
    ]
  },
  {
    "id": "mage_cataclysm",
    "classId": "mage",
    "name": "Cataclysm",
    "unlockLevel": 50,
    "cooldownMs": 40000,
    "castMs": 1000,
    "mpCost": 70,
    "range": 16,
    "target": "point",
    "effects": [
      {
        "type": "damage",
        "mult": 4.5,
        "area": {
          "shape": "circle_point",
          "radius": 8
        }
      }
    ]
  },
  {
    "id": "priest_prayer",
    "classId": "priest",
    "name": "Prayer of Healing",
    "unlockLevel": 20,
    "cooldownMs": 10000,
    "castMs": 1200,
    "mpCost": 40,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "heal",
        "mult": 1.8,
        "radius": 20
      }
    ]
  },
  {
    "id": "priest_judgment",
    "classId": "priest",
    "name": "Judgment",
    "unlockLevel": 50,
    "cooldownMs": 25000,
    "castMs": 1000,
    "mpCost": 50,
    "range": 20,
    "target": "point",
    "effects": [
      {
        "type": "damage",
        "mult": 2,
        "area": {
          "shape": "circle_point",
          "radius": 6
        }
      },
      {
        "type": "debuff",
        "stat": "def",
        "pct": -25,
        "durationMs": 8000
      },
      {
        "type": "debuff",
        "stat": "moveSpeed",
        "pct": -30,
        "durationMs": 8000
      }
    ]
  },
  {
    "id": "priest_purify",
    "classId": "priest",
    "name": "Purify",
    "unlockLevel": 12,
    "cooldownMs": 8000,
    "castMs": 1000,
    "mpCost": 20,
    "range": 20,
    "target": "ally",
    "effects": [
      {
        "type": "cleanse"
      }
    ]
  },
  {
    "id": "rogue_shake_off",
    "classId": "rogue",
    "name": "Shake Off",
    "unlockLevel": 12,
    "cooldownMs": 15000,
    "castMs": 1000,
    "mpCost": 15,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "cleanse"
      }
    ]
  },
  {
    "id": "mage_arcane_recall",
    "classId": "mage",
    "name": "Arcane Recall",
    "unlockLevel": 30,
    "cooldownMs": 60000,
    "castMs": 1000,
    "mpCost": 50,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "summon",
        "radius": 4
      }
    ]
  },
  {
    "id": "mage_glacier",
    "classId": "mage",
    "name": "Glacier",
    "unlockLevel": 35,
    "cooldownMs": 12000,
    "castMs": 1000,
    "mpCost": 35,
    "range": 16,
    "target": "point",
    "effects": [
      {
        "type": "damage",
        "mult": 1.4,
        "area": {
          "shape": "circle_point",
          "radius": 6,
          "maxTargets": 8
        }
      },
      {
        "type": "status",
        "status": "slow",
        "pct": 50,
        "durationMs": 4000,
        "chance": 50
      }
    ]
  },
  {
    "id": "priest_plague",
    "classId": "priest",
    "name": "Plague",
    "unlockLevel": 30,
    "cooldownMs": 15000,
    "castMs": 1000,
    "mpCost": 40,
    "range": 16,
    "target": "point",
    "effects": [
      {
        "type": "damage",
        "mult": 0.6,
        "area": {
          "shape": "circle_point",
          "radius": 6,
          "maxTargets": 8
        }
      },
      {
        "type": "dot",
        "mult": 1,
        "durationMs": 8000,
        "tickMs": 1000
      },
      {
        "type": "debuff",
        "stat": "def",
        "pct": -20,
        "durationMs": 10000
      }
    ]
  },
  {
    "id": "priest_cure_all",
    "classId": "priest",
    "name": "Cure All",
    "unlockLevel": 40,
    "cooldownMs": 20000,
    "castMs": 1000,
    "mpCost": 40,
    "range": 0,
    "target": "none",
    "effects": [
      {
        "type": "cleanse",
        "radius": 20
      }
    ]
  },
  {
    "id": "warrior_rose_blade",
    "classId": "warrior",
    "name": "Rose Blade",
    "unlockLevel": 10,
    "cooldownMs": 1000,
    "castMs": 0,
    "mpCost": 4,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.8
      }
    ]
  },
  {
    "id": "priest_radiant_strike",
    "classId": "priest",
    "name": "Radiant Strike",
    "unlockLevel": 10,
    "cooldownMs": 1000,
    "castMs": 0,
    "mpCost": 4,
    "range": 3,
    "target": "enemy",
    "effects": [
      {
        "type": "damage",
        "mult": 0.7
      }
    ]
  }
]
